<template>
  <div class="page">
    <div class="header-menu">
      <header-bar slot="head">
        <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
        <span>{{ $t(objSave.centerTitle) }}</span>
      </header-bar>
      <div class="invoiceInfos-btn" @click="editInvoice('')">
        <i class="fa fa-plus"></i>
        <span>{{ $t("mall.AdditionalInvoiceInformation") }}</span>
      </div>
    </div>
    <div class="page-content">
      <Scroll ref="scroll">
        <ul>
          <li>
            <div class="invoiceInfos-wrapper">
              <div v-for="invoiceInfo in model.invoiceInfos" @click="editInvoice(invoiceInfo.InvoiceID)" :key="invoiceInfo.InvoiceID">
                <div class="invoiceInfos-item" :style="{ 'padding-left': path == '/system/invoice' ? '0.266rem' : '' }">
                  <div class="invoiceInfos-leftItem">
                    <div>
                      <div class="invoiceInfos-content">
                        <span>{{ $t("mall.InvoiceTitle") }}</span>
                        <span>{{ invoiceInfo.InvoiceTitle }}</span>
                      </div>
                      <div class="invoiceInfos-content" v-if="invoiceInfo.IdentifyNumber != ''">
                        <span>{{ $t("mall.TariffItem") }}</span>
                        <span>{{ invoiceInfo.IdentifyNumber }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="invoiceInfos-rightItem">
                    <img src="/static/img/left1.png" />
                  </div>
                </div>
                <div class="border_bottom"></div>
              </div>
            </div>
          </li>
        </ul>
      </Scroll>
    </div>
  </div>
</template>
<style scoped>
  .header-menu {
    height: 3.557rem;
  }

  .header-menu ~ .page-content {
    top: 3.557rem;
  }

  .header-menu header {
    background-color: #12a3ff;
  }

  .invoiceInfos-btn {
    border: 1px solid rgb(18, 163, 255);
    border-radius: 0.106rem;
    text-align: center;
    padding: 0.133rem 0;
    margin: 0.266rem 0.532rem;
    font-size: 0.425rem;
  }

  .invoiceInfos-btn i {
    font-size: 0.478rem;
    color: #12a3ff;
    vertical-align: middle;
  }

  .invoiceInfos-btn span {
    color: #12a3ff;
    vertical-align: middle;
  }

  .invoiceInfos-item {
    background-color: #fff;
    padding: 0.266rem 0.266rem 0.266rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .invoiceInfos-content > span:first-child {
    width: 2.128rem;
    display: inline-block;
  }

  .invoiceInfos-content > span:last-child {
    width: 4.788rem;
    display: inline-block;
  }

  .invoiceInfos-leftItem {
    display: flex;
    align-items: center;
  }

  .invoiceInfos-leftItem label {
    display: inline-block;
    width: 1.276rem;
    height: 1.276rem;
    display: flex;
    align-items: center;
    justify-items: center;
  }

  .invoiceInfos-leftItem label input {
    margin: 0 auto;
  }

  .invoiceInfos-rightItem img {
    width: 0.425rem;
  }
</style>

<script>
  import Scroll from "../modules/Scroll.vue";
  import navBar from "../modules/navBar.vue";
  import UserService from "@/service/UserService";
  export default {
    name: "oftenPassenger",
    data() {
      return {
        model: {
          selectInvoice: [],
          invoiceInfos: [],
        },
        objSave: {
          centerTitle: "mall.InvoiceInformation",
          rightTitle: {
            isShow: true,
            type: "button",
            label: "share.confirmTxt",
            fnName: "fnSave",
          },
        },
        path: "",
      };
    },
    mounted() {
      let __self = this;
      __self.path = __self.$route.path;
    },
    activated() {
      let __self = this;
      __self.__init();
      __self.objSave.rightTitle = {};
    },
    computed: {
      UserID() {
        return this.profile.UserID;
      },
    },
    methods: {
      __init() {
        let __self = this;
        let data = {};
        data.RoleID = this.UserID;
        UserService.getInvoiceList(data).then(function(json) {
          if (json.isSucc) {
            __self.model.invoiceInfos = json.result.entities;
          }
        });
      },
      editInvoice(InvoiceID) {
        let __self = this;
        let query = {};
        if (InvoiceID != "") {
          query.InvoiceID = InvoiceID;
        }
        __self.$router.push({
          path: "/system/addInvoice",
          query: query,
        });
      },
      Save() {
        let __self = this;
        let invoiceInfo = [];
      },
    },
    components: {
      navBar,
      Scroll,
    },
  };
</script>
